export type IResponsive = Partial<{
  $isMobile: boolean;
  $isMd: boolean;
  $isLg: boolean;
  $isXLg: boolean;
  $viewName: BreakPointsType;
}>;

export const BreakPoints = {
  isMobile: 'isMobile',
  isMd: 'isMd',
  isLg: 'isLg',
  isXLg: 'isXLg',
} as const;

export type BreakPointsType = keyof typeof BreakPoints;
